import { Link, useNavigate } from "react-router-dom"
import { all_routes } from "../../router/all_routes"
import CollapseHeader from "../../../core/common/collapse-header/collapse-header"
import JoditEditor from "jodit-react"
import { DatePicker } from "antd"
import CommonTagsInputWithSuggestions from "../../../core/common/Taginput/index copy"
import { useEffect, useMemo, useRef, useState } from "react"
import dayjs, { Dayjs } from "dayjs"
import useApi from "../../../core/customhook/useApi"
import Swal from "sweetalert2"
import CommonTagsInput from "../../../core/common/Taginput"

interface Employee {
    employee_id: string;
    employee_name: string;
    department: string;
}

const AddTask = () => {

    const billingOptions = [
        { label: "Billable", value: "Billable" },
        { label: "Non-Billable", value: "Non-Billable" },
    ];

    const priorityOptions = [
        { label: "Low", value: "Low" },
        { label: "Medium", value: "Medium" },
        { label: "High", value: "High" },
    ];

    const navigate = useNavigate()
    const [attachments, setAttachments] = useState<File[]>([]);
    const [teamMembers, setTeamMembers] = useState<Employee[]>([]);
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [projectData, setProjectData] = useState([])
    const [content, setContent] = useState("");
    const [proName, setProName] = useState("");
    const [count, setCount] = useState(1)
    const [isDuration, setIsDuration] = useState(false);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [teamMemberData, setTeamMemberData] = useState([])
    const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const editor = useRef(null);
    const [error, setError] = useState("");
    const [tags, setTags] = useState<string[]>([]);
    const [data, setData] = useState({
        task_id: "",
        project_id: "",
        project_name: "",
        task_name: "",
        duration: "",
        work_hour: "",
        billing_type: "",
        priority: "",
        complete: 0,
        status: "Pending"
    });

    const {
        data: addprojectTaskResponse,
        loading: addprojectTaskDataLoading,
        error: addprojectTaskDataError,
        callApi: addProjectTask,
    } = useApi("/api/add-project-task", {
        method: "POST",
        autoCall: false,
    });

    const {
        data: taskData,
        loading: taskLoading,
        error: taskError,
    } = useApi("/api/get-all-project-task", {
        method: "GET",
        autoCall: true,
        dependencies: [count]
    });

    const getInputData = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        if (name === "work_hour") {
            const regex = /^[0-9]*$/;
            if (!regex.test(value)) return;
        }

        setData({ ...data, [name]: value });
    };

    const handleChangeStatus = () => {
        setIsDuration(!isDuration);
    };

    const config = useMemo(
        () => ({
            readonly: false,
        }),
        []
    );
    const postData = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!content || content.replace(/<[^>]*>/g, "").trim() === "") {
            setError("Description is required");
            return;
        }
        setError("")

        const formData = new FormData();
        formData.append("project_id", data.project_name);
        formData.append("task_name", data.task_name);
        formData.append("priority", data.priority);
        formData.append("billing_type", data.billing_type || "");
        formData.append("work_hour", data.work_hour || "");
        if (data.duration) formData.append("duration", data.duration);

        if (startDate) {
            formData.append("start_date", startDate.format("YYYY-MM-DD"));
        }

        if (endDate) {
            formData.append("due_date", endDate.format("YYYY-MM-DD"));
        }

        formData.append("description", content);
        tags.forEach((tag) => {
            formData.append("tags[]", tag);
        });
        teamMembers.forEach((member) => {
            formData.append("team_members[]", member.employee_id);
        });
        attachments.forEach((file) => {
            formData.append("file_path", file);
        });

        try {
            const respose = await addProjectTask(formData);
            if (respose.success) {
                Swal.fire({
                    title: "Success!",
                    text: "Project task added successfully.",
                    icon: "success",
                    confirmButtonText: "OK"
                });
                //  Reset all form states
                setData({
                    task_id: "",
                    project_id: "",
                    project_name: "",
                    task_name: "",
                    duration: "",
                    work_hour: "",
                    billing_type: "",
                    priority: "",
                    complete: 0,
                    status: "Pending"
                });
                setStartDate(null); // If you're using dayjs/moment or a Date object
                setEndDate(null);
                setContent(""); // Reset description/editor content
                setTags([]);
                setTeamMembers([]);
                setAttachments([]);
                document.getElementById("close_modal")?.click()
                setCount(count + 1)
                navigate('/tasks')
            }
        } catch (error) {
            console.log(error);
        }
    };

    const {
        data: projectResponse,
        loading: projectDataLoading,
        error: projectDataError,
    } = useApi("/api/get-project", {
        method: "GET",
        autoCall: true,
    });



    const {
        data: teamData,
        loading: teamLoading,
        error: teamError,
    } = useApi("/api/manager/team-member", {
        method: "GET",
        autoCall: true,
    });

    useEffect(() => {
        if (projectResponse?.success) {
            setProjectData(projectResponse?.projects)
        }
    }, [projectResponse])


    useEffect(() => {
        if (teamData?.success) {
            setTeamMemberData(teamData?.data)
        }
    }, [teamData])

    // useEffect(() => {
    //     if (taskData?.success) {
    //         setTask(taskData?.data)
    //     }
    // }, [taskData])

    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Tasks</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={all_routes.employeeDashboard}>
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">Employee</li>
                                <li className="breadcrumb-item active">Tasks</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="my-xl-auto right-content d-flex">
                        <div className="mb-2">
                            {/* <Link
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#add_task"
                                className="btn btn-primary d-flex align-items-center"
                            >
                                <i className="ti ti-circle-plus me-2" />
                                Add Task
                            </Link> */}
                        </div>
                        <div className="head-icons ms-2 mb-0">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* Breadcrumb */}
                {/* <div className="card"> */}
                <div className="container-fluid">
                    {/* Page Header */}
                    {/* <div className="row mb-4">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">Add New Task</h4>

                        </div>
                    </div> */}

                    {/* Card Wrapper */}
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={postData}>
                                <div className="row">

                                    {/* Project Name */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Project Name<sup className="text-danger">*</sup>
                                            </label>
                                            <div style={{ position: "relative", width: "100%" }}>
                                                <input
                                                    type="text"
                                                    name="projectName"
                                                    className="form-control me-2"
                                                    placeholder="Project Name"
                                                    style={{ width: "100%" }}
                                                    value={proName}
                                                    onChange={(
                                                        e: React.ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        const value = e.target.value;
                                                        setData({ ...data, project_name: value });
                                                        if (value.trim()) {
                                                            const matches = projectData.filter((item: any) =>
                                                                item.project_name
                                                                    .toLowerCase()
                                                                    .includes(value.toLowerCase())
                                                            );
                                                            setFilteredSuggestions(matches);
                                                            setShowSuggestions(true);
                                                        } else {
                                                            setFilteredSuggestions([]);
                                                            setShowSuggestions(false);
                                                        }
                                                    }}
                                                    required
                                                />
                                                {showSuggestions && filteredSuggestions.length > 0 && (
                                                    <div
                                                        className="dropdown-menu show"
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: "350px",
                                                            overflowY: "auto",
                                                            position: "absolute",
                                                            zIndex: 1000,
                                                        }}
                                                    >
                                                        <table className="table table-bordered table-hover mb-0">
                                                            <thead className="table-light sticky-top">
                                                                <tr>
                                                                    <th>Project Name</th>
                                                                    <th>Cost Center Code</th>
                                                                    <th>Department</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {filteredSuggestions.map((item, index) => (
                                                                    <tr
                                                                        key={index}
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => {
                                                                            setData({
                                                                                ...data,
                                                                                project_name: item.project_id,
                                                                            });
                                                                            setProName(item.project_name);
                                                                            setShowSuggestions(false);
                                                                        }}
                                                                    >
                                                                        <td>{item.project_name}</td>
                                                                        <td>{item.cost_center_code}</td>
                                                                        <td>{item.department_name}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div>
                                            {/* <div style={{ position: "relative" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Project Name"
                                                    value={proName}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        console.log('Value', value)
                                                        setData({ ...data, project_name: value });

                                                        if (value.trim()) {
                                                            const matches = projectData.filter((item: any) =>
                                                                item.project_name
                                                                    .toLowerCase()
                                                                    .includes(value.toLowerCase())
                                                            );
                                                            setFilteredSuggestions(matches);
                                                            setShowSuggestions(true);
                                                        } else {
                                                            setFilteredSuggestions([]);
                                                            setShowSuggestions(false);
                                                        }
                                                    }}
                                                />

                                                {showSuggestions && filteredSuggestions.length > 0 && (
                                                    <div
                                                        className="dropdown-menu show"
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: "350px",
                                                            overflowY: "auto",
                                                            position: "absolute",
                                                            zIndex: 1000,
                                                        }}
                                                    >
                                                        <table className="table table-bordered table-hover mb-0">
                                                            <thead className="table-light sticky-top">
                                                                <tr>
                                                                    <th>Project Name</th>
                                                                    <th>Cost Center Code</th>
                                                                    <th>Department</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {filteredSuggestions.map((item, index) => (
                                                                    <tr
                                                                        key={index}
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => {
                                                                            setData({
                                                                                ...data,
                                                                                project_name: item.project_id,
                                                                            });
                                                                            setProName(item.project_name);
                                                                            setShowSuggestions(false);
                                                                        }}
                                                                    >
                                                                        <td>{item.project_name}</td>
                                                                        <td>{item.cost_center_code}</td>
                                                                        <td>{item.department_name}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div> */}
                                        </div>
                                    </div>

                                    {/* Task Name */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Task Name<sup className="text-danger">*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="task_name"
                                                placeholder="Task Name"
                                                onChange={getInputData}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Team Members */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Team Members<sup className="text-danger">*</sup>
                                            </label>
                                            <CommonTagsInputWithSuggestions
                                                value={teamMembers}
                                                onChange={setTeamMembers}
                                                placeholder="Team Members"
                                                suggestions={teamMemberData}
                                            />
                                        </div>
                                    </div>

                                    {/* Start Date */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Start Date<sup className="text-danger">*</sup>
                                            </label>
                                            <DatePicker
                                                className="form-control"
                                                format={{ format: "DD-MM-YYYY", type: "mask" }}
                                                value={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                placeholder="DD-MM-YYYY"
                                                disabledDate={(current) =>
                                                    current && current.isBefore(dayjs().startOf("day"))
                                                }
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Due Date / Duration */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between">
                                                <label className="form-label">
                                                    {isDuration ? "Duration" : "Due Date"}
                                                </label>
                                                <span
                                                    onClick={handleChangeStatus}
                                                    style={{
                                                        color: "blue",
                                                        cursor: "pointer",
                                                        textDecoration: "underline",
                                                    }}
                                                >
                                                    {isDuration ? "Enter End Date" : "Enter Duration"}
                                                </span>
                                            </div>

                                            {isDuration ? (
                                                <div className="d-flex">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="duration"
                                                        placeholder="Enter Duration"
                                                        onChange={getInputData}
                                                        required
                                                    />
                                                    <select className="form-control ms-2" style={{ maxWidth: 100 }}>
                                                        <option>days</option>
                                                        <option>hrs</option>
                                                    </select>
                                                </div>
                                            ) : (
                                                <DatePicker
                                                    className="form-control"
                                                    format={{ format: "DD-MM-YYYY", type: "mask" }}
                                                    value={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                    placeholder="DD-MM-YYYY"
                                                    disabledDate={(current: any) =>
                                                        current &&
                                                        (current.isBefore(dayjs().startOf("day")) ||
                                                            (startDate && current.isBefore(startDate)))
                                                    }
                                                    required
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {/* Work Hours */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Work Hours (to be evenly distributed to assigned members)
                                                <sup className="text-danger">*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="work_hour"
                                                placeholder="Work Hours"
                                                value={data.work_hour}
                                                onChange={getInputData}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Tags */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Tags<sup className="text-danger">*</sup>
                                            </label>
                                            <CommonTagsInput
                                                value={tags}
                                                onChange={setTags}
                                                placeholder="Add new"
                                                className="custom-input-class"
                                            />
                                            <small className="text-danger">(Press enter to add more)</small>
                                        </div>
                                    </div>

                                    {/* Billing Type */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Billing Type<sup className="text-danger">*</sup>
                                            </label>
                                            <select
                                                className="form-control"
                                                name="billing_type"
                                                onChange={getInputData}
                                                required
                                            >
                                                <option value="">Select</option>
                                                {billingOptions.map((item) => (
                                                    <option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Priority */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Priority<sup className="text-danger">*</sup>
                                            </label>
                                            <select
                                                className="form-control"
                                                name="priority"
                                                onChange={getInputData}
                                                required
                                            >
                                                <option value="">Select</option>
                                                {priorityOptions.map((item) => (
                                                    <option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>


                                    {/* Description */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Description<sup className="text-danger">*</sup>
                                            </label>
                                            <JoditEditor
                                                className={error ? "border border-danger" : ""}
                                                ref={editor}
                                                value={content}
                                                config={config}
                                                onBlur={(newContent) => setContent(newContent)}
                                            />
                                            {error && <small className="text-danger">{error}</small>}
                                        </div>
                                    </div>

                                    {/* Actions */}
                                    <div className="col-12 text-end">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary me-2"
                                            onClick={() => window.history.back()}
                                        >
                                            <i className="ti ti-arrow-left me-1" />
                                            Back
                                        </button>
                                        <button type="submit" className="btn btn-primary">
                                            Add Task
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* </div> */}
            </div>
        </div>
    )
}

export default AddTask;